module.exports = __webpack_public_path__ + "static/media/gharch.699fbacc.png";